import { fetchToken } from "../../../common/FetchCookie";

const BASE_URL = "https://api.indiahirings.com/api/profile";

export const sendVerificationEmail = async () => {
  try {
    const token = await fetchToken();
    const response = await fetch(`${BASE_URL}/send-verification-email`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || data.msg || "Failed to send verification email");
    }

    return data;
  } catch (error) {
    console.error("Send Verification Email Error:", error);
    throw new Error(error.message || "Failed to send verification email");
  }
};

export const getEmailVerifiedStatus = async (verificationToken) => {
  try {
    const authToken = await fetchToken();

    const response = await fetch(`${BASE_URL}/verify-email/${verificationToken}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || data.msg || `Failed to verify email: ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error("Verify Email Error:", error);
    throw new Error(error.message || "Failed to verify email");
  }
};